import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus';

const documentationContextual = () => {

    let docs = document.querySelectorAll('.doc-con');

    let documentationConstructor = (id) => {
        Vue.component('documentation-contextual-template', {
            data: function() {
                return {
                    emailDocs: [], //for emailing,
                    mailto: null,
                    mailtoAll: null,
                    totalItems: null,
                    items: [],
                }
            },
            watch: {
                "emailDocs": function() {
                    let mailto = "mailto:?subject=Badger%20Meter%20Document%20Links&body=";
                    this.emailDocs.forEach(item => {
                        mailto = `${mailto}${encodeURIComponent(item.name)}:%20${item.url}%0D%0A`;
                    });
                    this.mailto = mailto;
                },
                "items": function() {
                    this.shareAll();
                },
            },
            methods: {
                updateEmailDocs(data) {
                    let item = this.emailDocs.find(item => {
                        return item.id == data.id;
                    });

                    if (!item) {
                        this.emailDocs = [...this.emailDocs, data];
                    } else {
                        this.emailDocs.splice(this.emailDocs.indexOf(item),1);
                    }
                },
                updateItems(data) {
                    this.items.push(data);
                },
                shareAll() {
                    let mailto = "mailto:?subject=Badger%20Meter%20Document%20Links&body=";
                    this.items.forEach(item => {
                        mailto = `${mailto}${encodeURIComponent(item.name)}: ${item.url}%0D%0A`;
                    });
                    this.mailtoAll = mailto;
                },
            },
            mounted() {
                EventBus.$on('email-docs', (data) => {
                    this.updateEmailDocs(data);
                });
                EventBus.$on('update-items', (data) => {
                    this.updateItems(data);
                });
                this.shareAll(); //init share all

                this.totalItems = Array.from(this.$el.querySelectorAll('.doc-card')).length;
            }
        });

        Vue.component('doc-con-item', {
            data: function() {
                return {
                    isBookmarked: false,
                    id: null,
                    type: "documentId",
                    name: null,
                    url: null,
                    seeAll: null, //is "see all" feature enabled,
                    seeAllOpen: null,
                    seeAllLabel: null,//label
                    moreContent: null,
                }
            },
            computed: {
                saved: function() {
                    return store.state.favorites[`${this.type}`];
                }
            },
            watch: {
                saved: function() {
                    this.isBookmarked = this.saved.includes(this.id) ? true : false;
                },
                "seeAll": function() {
                    if (this.seeAll) {
                        this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                    }
                },
                "seeAllOpen": function() {
                    if (this.seeAll) {
                        this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                    }
                }
            },
            methods: {
                emailDoc() {
                    EventBus.$emit('email-docs', {"name": this.name, "url": this.url, "id": this.id});
                },
                handleBookmark() {
                    store.commit('updateFavorites', {
                        id: this.id,
                        type: this.type,
                        action: this.isBookmarked ? "remove" : "add"
                    });
                    store.dispatch('checkFavorites');
                },
                toggleSeeAll() {
                    this.seeAllOpen = !this.seeAllOpen;
                },
                initSeeAll() {
                    if (this.$refs.seeAllContent) {
                        let details = this.$refs.seeAllContent.innerHTML.split(',');
                        this.seeAll = details.length > 3 ? true : false;

                        let truncatedDetails = details.slice(0,3).join();
                        let moreDetails = details.slice(3).join();

                        this.moreContent = moreDetails;
                        this.$refs.seeAllContent.innerHTML = `${truncatedDetails},`;
                    }
                }
            },
            mounted() {
                this.id = this.$refs.bookmark.dataset.documentId;
                this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                this.name = this.$refs.name.innerText;
                this.url = this.$refs.name.getAttribute('href');
                this.$nextTick(() => {
                    EventBus.$emit('update-items', {"name": this.name, "url": this.url, "id": this.id})
                });
                this.initSeeAll();
            }
        });

        new Vue({
            el: `.doc-con-${id}`,
        }).$mount(`.doc-con-${id}`, true);
    }

    if (docs.length > 0) {
        docs.forEach((item, index) => {
            item.classList.add(`doc-con-${index}`);
            documentationConstructor(index);
        })
    }

}

export default documentationContextual;